import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./index.scss";
import menuImage from "../../../assets/menuImage.png";
import AppButton from "../../appButton";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
const Navbar = () => {
  const location = useLocation();
  const [activeMenu, setActiveMenu] = useState(location.pathname); // Initialise avec la route actuelle
  const navigate = useNavigate();
  // Fonction pour mettre à jour l'état actif
  const handleMenuClick = (path) => {
    setActiveMenu(path);
  };
  const [isOpen, setIsOpen] = useState(false);

  // Variants pour l'animation
  const menuVariants = {
    hidden: { opacity: 0, y: 50 }, // Menu caché
    visible: { opacity: 1, y: 0 }, // Menu visible
  };
  return (
    <div className="custom-section  ">
      <div className="row align-items-center menu-web justify-content-center">
        {/* Menu Section */}
        <div className="col-md-6  text-center menu-section">
          <nav className="menu-container">
            <ul>
              <li
                className={`menu-item border-rt ${activeMenu === "/" ? "active" : ""}`}
              >
                <Link to="/" onClick={() => handleMenuClick("/")}>
                  Accueil
                </Link>
              </li>
              <li
                className={`menu-item ${
                  activeMenu === "/aPropo" ? "active" : ""
                }`}
              >
                <Link to="/aPropo" onClick={() => handleMenuClick("/aPropo")}>
                  A propos
                </Link>
              </li>
              <li
                className={`menu-item ${
                  activeMenu === "/faire-don" ? "active" : ""
                }`}
              >
                <Link
                  to="/faire-don"
                  onClick={() => handleMenuClick("/faire-don")}
                >
                  Faire un Don
                </Link>
              </li>
              <li
                className={`menu-item ${
                  activeMenu === "/rejoignez-nous" ? "active" : ""
                }`}
              >
                <Link
                  to="/rejoignez-nous"
                  onClick={() => handleMenuClick("/rejoignez-nous")}
                >
                  Rejoignez-nous
                </Link>
              </li>
              <li
                className={`menu-item ${
                  activeMenu === "/realisation" ? "active" : ""
                }`}
              >
                <Link
                  to="/realisation"
                  onClick={() => handleMenuClick("/realisation")}
                >
                  Nos realisation
                </Link>
              </li>
              <li
                className={`menu-item border-rb ${
                  activeMenu === "/contact" ? "active" : ""
                }`}
              >
                <Link to="/contact" onClick={() => handleMenuClick("/contact")}>
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>

        {/* Image Section */}
        <div className="col-md-6 image-section text-center">
          <img src={menuImage} alt="Placeholder" className="img-fluid " />
          <div className="donate-button">
            <AppButton
              text="FAIRE UN DON MAINTENANT"
              className="btn-font"
              color="orange"
              size="large"
              onClick={() => {
                navigate("/faire-don");
                window.scrollTo(0, 0);
              }}
            />
          </div>
        </div>
      </div>
      <div className="sidebar-container menu-mobile">
        {/* Menu items */}

        <motion.div
          initial="hidden"
          animate="visible"
          exit="hidden"
          variants={menuVariants}
          transition={{ duration: 0.5 }}
          className="menu-items"
        >
          <button
            className={`menu-button ${
              activeMenu === "/contact" ? "active" : ""
            }`}
          >
            <Link to="/contact" onClick={() => handleMenuClick("/contact")}>
              CONTACT
            </Link>
          </button>
          <button
            className={`menu-button ${
              activeMenu === "/realisation" ? "active" : ""
            }`}
          >
            <Link
              to="/realisation"
              onClick={() => handleMenuClick("/realisation")}
            >
              NOS RÉALISATIONS
            </Link>
          </button>
          <button
            className={`menu-button ${
              activeMenu === "/rejoignez-nous" ? "active" : ""
            }`}
          >
            {" "}
            <Link
              to="/rejoignez-nous"
              onClick={() => handleMenuClick("/rejoignez-nous")}
            >
              REJOIGNEZ-NOUS
            </Link>
          </button>
          <button
            className={`menu-button ${
              activeMenu === "/faire-don" ? "active" : ""
            }`}
          >
            <Link to="/faire-don" onClick={() => handleMenuClick("/faire-don")}>
              Faire un Don
            </Link>
          </button>
          <button
            className={`menu-button ${activeMenu === "/aPropo" ? "active" : ""}`}
          >
            {" "}
            <Link to="/aPropo" onClick={() => handleMenuClick("/aPropo")}>
              À PROPOS
            </Link>
          </button>
          <button
            className={`menu-button ${activeMenu === "/" ? "active" : ""}`}
          >
            <Link to="/" onClick={() => handleMenuClick("/")}>
              ACCUEIL
            </Link>
          </button>
        </motion.div>

        {/* Donation buttons */}
      </div>
    </div>
  );
};

export default Navbar;
